import ENV from '../constants/envConstants';
import axios from "../axiosConfig";
import { useQuery } from 'react-query';
import { useCookies } from 'react-cookie';
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useLocation } from "react-router";

const createAccountMessage = () =>
  Swal.fire({
    title: "You must create an account",
    text: "Create your account before proceeding to this step!",
    confirmButtonText: "Got it",
  });

export function usePlace(placeId) {
    const [cookies, setCookie, removeCookie] = useCookies(["placeId"]);
    return useQuery(
      "placeDetail",
      async () => {
        const { data } = await axios.get(
          ENV.BACKEND_URL + "/restaurants/places/" + placeId + "/",
        );
        return data;
      },
      {
        enabled: placeId ? true : false,
        onError: (error) => {
          const isCancelledError = error.constructor.name === "CancelledError";
          if (!isCancelledError) {
            const status = error.response.status;
            if (status === 403 || status === 404) {
              removeCookie("placeId");
              removeCookie("menuId");
              createAccountMessage();
            }
          }
        },
      }
    );
}

export function useCsrf() {
  return useQuery(
    "csrfToken",
    async () => {
      const { data } = await axios.get(`${ENV.BACKEND_URL}/restaurants/set-csrf/`);
      return data;
    },
    {
      retry: false,
    }
  );
}

export function useUser() {
  let navigate = useNavigate();
  let location = useLocation();
  return useQuery(
    "userDetail",
    async () => {
      const { data } = await axios.get(`${ENV.BACKEND_URL}/restaurants/users/`, {
        withCredentials: true,
      });
      return data;
    },
    {
      retry: false,
      onError: (error) => {
        const isCancelledError = error.constructor.name === "CancelledError";
        if (!isCancelledError) {
          const status = error.response.status;
          if (status === 403 && location.pathname != "/get-started") {
            navigate("/get-started", { replace: true });
            createAccountMessage();
          }
        }
      },
    }
  );
}

export function useMenu(menuId, opts) {
  var menuDetailHandle;
  if (menuId) {
    menuDetailHandle = async () => {
      const { data } = await axios.get(ENV.BACKEND_URL + "/restaurants/menus/" + menuId + "/");
      return data;
    };
  } else {
    menuDetailHandle = null;
  }
  return useQuery("menuDetail", menuDetailHandle);
}

export const useDiscoverySettings = () => {
  return useQuery("discoverySettings", async () => {
      const { data } = await axios.get(
      ENV.BACKEND_URL + "/restaurants/discovery-settings/");
      return data;
  });
}
